import React, { Fragment, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import OrderServices from '../../apis/Order/OrderServices';
//* Required Components
import { ErrorToaster, SuccessToaster } from '../../components/Toaster/Toaster';
import colors from '../../styles/colors';
import { getTimeDate } from '../../utils/DateFormate';
import { Loading } from '../../components/UI/Loader';
//* MUI Imports
import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { Recommend, RequestQuote, Done, Visibility, KeyboardArrowLeft, KeyboardArrowRight, } from '@mui/icons-material'
import { Paper, Box, Grid, Typography, tooltipClasses, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip, IconButton } from '@mui/material';
import useAuth from '../../hooks/useAuth';
import moment from 'moment';
import ProfileServices from '../../apis/Profile/ProfileServices';
import AuthServices from '../../apis/Auth/AuthServices';
import { useForm } from 'react-hook-form';
import { InputField } from '../../components/Fields/TextField';
import { PrimaryButton } from '../../components/Button/Button';
import AddressForm from '../../components/Dialog/AddressForm';

const PharmacyOrder = () => {

  const navigate = useNavigate()
  const { pharmacyId } = useAuth();

  const { register, handleSubmit, formState: { errors }, setValue, getValues } = useForm();

  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
    const [latitude2, setLatitude2] = useState(0);
  const [longitude2, setLongitude2] = useState(0);
  // *For Dialog
  const [addressFormDialog, setAddressFormDialog] = useState(false);
  const [addressFormDialog2, setAddressFormDialog2] = useState(false);

  const createPharmacyOrder = async (formData) => {
    setLoading(true)
    try {
      let obj = {
        customer_name: formData.name,
        customer_address: formData.cus_address,
        customer_phone: formData.phone,
        pickup_address: formData.pickup_address,
        pickup_google_address: formData.pickup_google_address,
        pickup_latitude: latitude2,
        pickup_longitude: longitude2,
        google_map_location: formData.address,
        latitude: latitude,
        longitude: longitude,
        payment_mode:formData?.payment_mode,
        payment_amount:formData?.payment_amount,
        order_details:formData?.order_detail
      }
      const { data, message } = await ProfileServices.createPharmacyOrder(obj);
      SuccessToaster(message)
      navigate("/pharmacy-orders-list")
    }
    catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  const handleAddress = (data) => {
    try {
      setValue('address', data?.address)
      setLatitude(data.latitude)
      setLongitude(data.longitude)
    } catch (error) {
      console.log('file: create-pharmacy.js:50 => handleAddress => error:', error)
    }
  }

    const handleAddress2 = (data) => {
    try {
      setValue('pickup_google_address', data?.address)
      setLatitude2(data.latitude)
      setLongitude2(data.longitude)
    } catch (error) {
      console.log('file: create-pharmacy.js:50 => handleAddress => error:', error)
    }
  }

//   const getProfile = async () => {
//     setLoader(true)
//     try {
//       const { data } = await ProfileServices.getProfileDetail()
//       if (data === null) return
//       setValue('name', data.result?.name)
//       setValue('email', data.result?.email)
//       setValue('phone', data.result?.phone)
//       setValue('address', data.result?.address?.address)
//       setLatitude(data.result?.address?.latitude)
//       setLongitude(data.result?.address?.longitude)
//     }
//     catch (error) {
//       ErrorToaster(error)
//     } finally {
//       setLoader(false)
//     }
//   }

//   useEffect(() => {
//     getProfile()
//   }, [])

  return (
    <Fragment>

      {/* ========== Address Form Dialog Box ========== */}
      <AddressForm open={addressFormDialog} onClose={() => setAddressFormDialog(false)} defaultData={{ address: getValues('address'), latitude: latitude, longitude: longitude }} save={(data) => { handleAddress(data); setAddressFormDialog(false) }} />
      <AddressForm open={addressFormDialog2} onClose={() => setAddressFormDialog2(false)} defaultData={{ address: getValues('pickup_google_address'), latitude: latitude2, longitude: longitude2 }} save={(data) => { handleAddress2(data); setAddressFormDialog2(false) }} />

      <Box sx={{
        backgroundColor: colors.lightGray, p: 3, borderRadius: "12px"
        // , width: "calc(100vw - 370px)"
      }} >
        <Grid container alignItems="center" justifyContent="space-between"
          sx={{
            bgcolor: colors.white, p: 2, borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">Pharmacy Order</Typography>
          </Grid>
          <Grid item xs={6} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <BreadCrumbs currentPage={['Pharmacy Orders']} />
          </Grid>
        </Grid>
        {loader ? (
          <Box sx={{ width: 1, textAlign: "center", pt: 5 }}>
            <Loading />
          </Box>
        ) : (
          <Fragment>
            <Box sx={{ bgcolor: colors.white, p: 3, borderRadius: "12px", mt: 2 }}>
              <Typography component={"form"} onSubmit={handleSubmit(createPharmacyOrder)}>
                <Grid container spacing={2} alignItems="center">
                  
                  <Grid item xs={12} md={6}>
                    <InputField
                      label="Customer name"
                      error={errors?.name?.message}
                      register={register("name", {
                        required: 'Please enter Customer Name',
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputField
                      label="Customer Address"
                      error={errors?.cus_address?.message}
                      register={register("cus_address", {
                        required: 'Please enter Customer Address',
                      })}
                    />
                  </Grid>
           
                  <Grid item xs={12} md={6}>
                    <Box sx={{ cursor: 'pointer' }} onClick={() => setAddressFormDialog(true)}>
                      <InputField
                    
                        label="Google Map Location"
                        placeholder='Google Map Location'
                        disabled={true}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        error={errors?.address?.message}
                        register={register("address", {
                          required: 'Please enter address',
                        })}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6} sx={{ display: "flex", gap: '5px', alignItems: 'flex-start' }}>
                    
                    <InputField
                      variant="standard"
                      label="Phone"
                      inputProps={{ minLength: 9, maxLength: 9 }}
                      placeholder={"50 123 4567"}
                      error={errors?.phone?.message}
                      register={register("phone", {
                        required: 'Please enter phone number',
                      })}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <InputField
                      label="Pickup Address"
                      error={errors?.pickup_address?.message}
                      register={register("pickup_address", {
                        required: 'Please enter Pickup Address',
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box sx={{ cursor: 'pointer' }} onClick={() => setAddressFormDialog2(true)}>
                      <InputField
                    
                        label="Pickup Map Location"
                        placeholder='Pickup Map Location'
                        disabled={true}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        error={errors?.pickup_google_address?.message}
                        register={register("pickup_google_address", {
                          required: 'Please enter address',
                        })}
                      />
                    </Box>
                  </Grid>

                 
                  <Grid item xs={12} md={6}>
                    <InputField
                      label="Payment Amount"
                     
                      error={errors?.payment_amount?.message}
                      register={register("payment_amount", {
                        required: 'Please enter Payment Amount',
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputField
                      label="Payment Mode"
                      
                      error={errors?.payment_mode?.message}
                      register={register("payment_mode", {
                        required: 'Please enter Payment Mode',
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputField
                      label="Order Details"
                      rows={3}
                      multiline
                      error={errors?.order_detail?.message}
                      register={register("order_detail", {
                        // required: 'Please enter order Detail',
                      })}
                    />
                  </Grid>
                </Grid>
                <Box sx={{ mt: 2, display: "flex", alignItems: "center", justifyContent: "center" }}>

                  <PrimaryButton
                    title={"Save changes"}
                    type="submit"
                    loading={loading}
                  />
                </Box>
              </Typography>
            </Box>
          </Fragment>
        )}
      </Box >
    </Fragment >
  )
}

export default PharmacyOrder